import React from "react"
import NavLink from "../NavLink"
import PricingTld from "../../components/ui/PricingTld"
import CurrencyContext from "../../context/CurrencyContext"
import { useStaticQuery, graphql } from "gatsby"

const FeaturedTlds = () => {
  const allData = useStaticQuery(graphql`
    query {
      allTldsPricingJson(
        filter: {
          tld: { in: [".in", ".co.in", ".com", ".net", ".org", ".co.uk", ".us"] }
        }
      ) {
        edges {
          node {
            tld
            slug
            pricing {
              INR {
                prefix
                suffix
                register
                renew
              }
              MYR {
                prefix
                suffix
                register
                renew
              }
              SGD {
                prefix
                suffix
                register
                renew
              }
              USD {
                prefix
                suffix
                register
                renew
              }
              GBP {
                prefix
                suffix
                register
                renew
              }
            }
          }
        }
      }
    }
  `)
  const tldPrice = allData.allTldsPricingJson.edges

  return (
    <>
      <CurrencyContext.Consumer>
        {(context) => {
          return (
            <>
              {tldPrice.map((item, index) => (
                <div className="col-12 col-md-3 mb-3" key={index}>
                  <div className="card card-shadow rounded mb-3 h-100">
                    <div className="card-body p-4 pb-0">
                      <h4 className="card-title">{item.node.tld}</h4>
                      <div className="card-text mb-0">
                        <PricingTld
                          pricing={item.node.pricing}
                          tld={item.node.tld}
                        />
                      </div>
                      <NavLink
                        to={`/tlds/` + item.node.slug + `-domain/`}
                        title={item.node.tld + ` domain`}
                        className="stretched-link hide"
                      >
                        {item.node.tld} Domain
                      </NavLink>
                    </div>
                  </div>
                </div>
              ))}
            </>
          )
        }}
      </CurrencyContext.Consumer>
    </>
  )
}

export default FeaturedTlds
